
import axiosWrap from '../axiosWrap';
import axiosFormData from '../axiosFormData';

import * as reqBodyMaker from './mvRequestBodyMaker';

const familyrl = [{'role_id':'0','role_name':'戶長'},{'role_id':'1','role_name':'配偶'},{'role_id':'2','role_name':'子女'},{'role_id':'3','role_name':'父母'},{'role_id':'5','role_name':'孫子女'},{'role_id':'4','role_name':'其他'}]


export const getFamilyrl =  () => familyrl;

//個險保障重新計算
export const recalculateCoverage = async(userId, plcno) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0106/recalculateCoverage`, reqBodyMaker.recalculateCoverage(userId, plcno), null, '保障重新計算', 'mymv', 'MV');
}

//團險保障重新計算
export const recalculateCoverageGroup = async(userId, plcno, csidno) => {
      return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0106/recalculateCoverageGroup`, reqBodyMaker.recalculateCoverageGroup(userId, plcno, csidno), null, '保障重新計算', 'mymv', 'MV');
}

//查詢Excel資料
export const getExcelData = async(userId, category) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/getExcelData`, reqBodyMaker.getExcelData(userId, category), null, '查詢Excel資料', 'mymv', 'MV')
}

//下載Excel
export const getExcel = async(userId, sendData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/download`, reqBodyMaker.getExcel(userId, sendData), 'arraybuffer', '下載Excel', 'mymv', 'MV')
}

//商品設定-保障分類設定-查詢目前存檔的使用者
export const querySaveId = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/querySaveId`, reqBodyMaker.querySaveId(userId, reqData), null, '查詢目前存檔的使用者', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢保障中分類
export const queryMidCategory = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/queryMidCategory`, reqBodyMaker.queryMidCategory(userId, reqData), null, '查詢保障中分類', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢該中分類代碼最大的數字
export const queryMidCategoryMaxNum = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/queryMidCategoryMaxNum`, reqBodyMaker.queryMidCategory(userId, reqData), null, '查詢該中分類代碼最大的數字', 'mymv', 'MV');
}

//商品設定-保障分類設定-新增保障群組中分類
export const insertMidCategory = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/insertMidCategory`, reqBodyMaker.insertMidCategory(userId, reqData), null, '新增保障群組中分類', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢所有保障細項
export const querySmallCategoryAll = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/querySmallCategoryAll`, reqBodyMaker.querySmallCategoryAll(userId), null, '查詢所有保障細項', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢尚未加入群組的細項
export const queryNotJoinGroup = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/queryNotJoinGroup`, reqBodyMaker.querySmallCategoryAll(userId, reqData), null, '查詢尚未加入群組的細項', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢已加入群組保障細項
export const querySmallCategoryByCode = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/querySmallCategoryByCode`, reqBodyMaker.querySmallCategoryByCode(userId, reqData), null, '查詢已加入群組保障細項', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢已加入群組保障細項_未覆核
export const querySmallCategoryNotCheckByCode = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/querySmallCategoryNotCheckByCode`, reqBodyMaker.querySmallCategoryByCode(userId, reqData), null, '查詢已加入群組保障細項(未覆核)', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢要移除群組保障細項_未覆核
export const querySmallCategoryNotCheckByCode2 = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/querySmallCategoryNotCheckByCode2`, reqBodyMaker.querySmallCategoryByCode(userId, reqData), null, '查詢要移除群組保障細項(未覆核)', 'mymv', 'MV');
}

//商品設定-保障分類設定-查詢異動紀錄
export const queryChangeRecords = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/queryChangeRecords`, reqBodyMaker.querySmallCategoryByCode(userId, reqData), null, '查詢異動紀錄s', 'mymv', 'MV');
}

//商品設定-保障分類設定-異動保障細項
export const insertDTMVZ006 = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/insertDTMVZ006`, reqBodyMaker.insertDTMVZ006(userId, reqData), null, '異動保障細項', 'mymv', 'MV');
}

//商品設定-保障分類設定-異動保障中項
export const insertDTMVZ006MID = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/insertDTMVZ006MID`, reqBodyMaker.insertDTMVZ006MID(userId, reqData), null, '異動保障中項', 'mymv', 'MV');
}

//商品設定-保障分類設定-執行覆核
export const doCheckCategory = async(userId, code) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_1000/doCheckCategory`, reqBodyMaker.doCheckCategory(userId, code), null, '執行覆核', 'mymv', 'MV');
}

//商品設定-查詢保障項目名稱
export const getCoverageItemDetailByName = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_0700/getCoverageItemDetailByName`, reqBodyMaker.getCoverageItemDetailByName(userId, reqData), null, '查詢保障項目名稱', 'mymv', 'MV');
}

//商品設定-查詢保障設定檔
export const getReportSettings = async(userId, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/getReportSettings`, reqBodyMaker.getReportSettings(userId, type), null, '查詢保障設定檔', 'mymv', 'MV');
}

//商品設定-查詢保障設定異動紀錄
export const getReportChangeRecords = async(userId, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/getReportChangeRecords`, reqBodyMaker.getReportSettings(userId, type), null, '查詢保障設定檔', 'mymv', 'MV');
}

//商品設定-新增保障設定
export const insertReport = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/insertReport`, reqBodyMaker.insertReport(userId, reqData), null, '新增保障設定', 'mymv', 'MV');
}

//商品設定-更新保障設定
export const updateReport = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/updateReport`, reqBodyMaker.updateReport(userId, reqData), null, '更新保障設定', 'mymv', 'MV');
}

//商品設定-儲存保障設定
export const saveReport = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/saveReport`, reqBodyMaker.saveReport(userId, reqData), null, '儲存保障設定', 'mymv', 'MV');
}

//商品設定-複製保障設定
export const copyReport = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/copyReport`, reqBodyMaker.updateReport(userId, reqData), null, '複製保障設定', 'mymv', 'MV');
}

//商品設定-查詢保障設定列表
export const getReportList = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/getReportList`, reqBodyMaker.getReportList(userId), null, '查詢保障設定列表', 'mymv', 'MV');
}

//商品設定-查詢保障群組和特殊條件列表
export const getOptionsList = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/getOptionsList`, reqBodyMaker.getReportList(userId), null, '查詢保障群組和特殊條件列表', 'mymv', 'MV');
}

//商品設定-搜尋保障設定
export const searchReport = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_2000/searchReport`, reqBodyMaker.searchReport(userId, reqData), null, '搜尋保障設定', 'mymv', 'MV');
}

//商品設定-查詢特殊條件列表
export const getSpecialConditionsList = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionsList`, reqBodyMaker.getSpecialConditionsList(userId), null, '查詢特殊條件列表', 'mymv', 'MV');
}

//商品設定-查詢特殊條件最新編號
export const getSpecialConditionNextCode = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionNextCode`, reqBodyMaker.getSpecialConditionsList(userId), null, '查詢特殊條件列表', 'mymv', 'MV');
}

//商品設定-新增特殊條件
export const insertSpecialCondition = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/insertSpecialCondition`, reqBodyMaker.insertSpecialCondition(userId, reqData), null, '查詢特殊條件列表', 'mymv', 'MV');
}

//商品設定-查詢特殊條件
export const getSpecialConditionDetail = async(userId, code) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionDetail`, reqBodyMaker.getSpecialConditionDetail(userId, code), null, '查詢特殊條件', 'mymv', 'MV');
}

//商品設定-查詢特殊條件編輯頁內容
export const getSpecialConditionDetailForEdit = async(userId, code) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionDetailForEdit`, reqBodyMaker.getSpecialConditionDetail(userId, code), null, '查詢特殊條件編輯頁內容', 'mymv', 'MV');
}

//商品設定-查詢特殊條件異動紀錄
export const getSpecialConditionChangeRecords = async(userId, type) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionChangeRecords`, reqBodyMaker.getSpecialConditionDetail(userId, type), null, '查詢特殊條件異動紀錄檔', 'mymv', 'MV');
}

//商品設定-查詢特殊條件編輯頁選項
export const getSpecialConditionDetailFormOptions = async(userId, company, product) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getSpecialConditionDetailFormOptions`, reqBodyMaker.getSpecialConditionDetailFormOptions(userId, company, product), null, '查詢特殊條件編輯頁選項', 'mymv', 'MV');
}

//商品設定-查詢特殊條件編輯頁公司別下拉選項
export const getCompanyOptions = async(userId) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getCompanyOptions`, reqBodyMaker.getCompanyOptions(userId), null, '查詢特殊條件編輯頁公司別下拉選項', 'mymv', 'MV');
}

//商品設定-查詢特殊條件編輯頁險種下拉選項
export const getProductOptions = async(userId, company) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/getProductOptions`, reqBodyMaker.getProductOptions(userId, company), null, '查詢特殊條件編輯頁選項', 'mymv', 'MV');
}

//商品設定-更新特殊條件
export const updateSpecialCondition = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/updateSpecialCondition`, reqBodyMaker.updateSpecialCondition(userId, reqData), null, '更新特殊條件', 'mymv', 'MV');
}

//商品設定-儲存特殊條件
export const saveSpecialCondition = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVY0_3000/saveSpecialCondition`, reqBodyMaker.saveSpecialCondition(userId, reqData), null, '儲存特殊條件', 'mymv', 'MV');
}

// 判斷傳入單位代碼是否有在權限版控裡
export const checkUnitExist = async(userId, unitCode) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/checkUnitExists`, reqBodyMaker.checkUnitExist(userId, unitCode), null, '判斷傳入單位代碼是否有在權限版控裡', 'mymv', 'MV');
}

//同業保單資料查詢 
export const queryPeerPolicyDataAPI = async(userId, reqData) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0300/queryPeerPolicyDataAPI`, {
        header: { userId: userId },
        body: reqData
    }, null, '同業保單資料查詢', 'mymv', 'MV');
}

// 下載辨識圖片
export const downloadImageBlobAPI = async(userId, fileName) => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVI0_0300/downloadImageBlobAPI`, {
        header: { userId: userId },
        body: { fileName: fileName }
    }, 'blob', '下載辨識圖片', 'mymv', 'MV');
}

//判斷 OCR 功能是否開啟 
export const checkOcrSwitch = async(userId = '') => {
    return await axiosWrap('Post', `/servlet/HttpDispatcher/MVC0_0102/checkOcrSwitch`, {
        header: { userId: userId },
        body: {}
    }, null, '判斷 OCR 功能是否開啟', 'mymv', 'MV');
};